import { render, staticRenderFns } from "./OnPlansEnSouffrance.vue?vue&type=template&id=74b94e23&"
import script from "./OnPlansEnSouffrance.vue?vue&type=script&lang=js&"
export * from "./OnPlansEnSouffrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports